import { BrandDefinition } from '../brand.interface';
import { createDefaultBrandTexts, defineBrandConfig } from '../define-brand-config';
import { defineThemeVariables } from '../theme-variable';
import { logo as alucertoLogo } from './logo-base64';

const buildBrandAssetUrl = (assetPath: string): string => `assets/brands/alucerto/${assetPath}`;

const buildDefaultAssets = () => ({
  logoUrl: buildBrandAssetUrl('img/logo.png'),
  footerLogoUrl: buildBrandAssetUrl('svg/isologo-blanco.svg'),
  faviconUrl: buildBrandAssetUrl('img/favicon-32x32.png'),
  favicon16Url: buildBrandAssetUrl('img/favicon-16x16.png'),
  favicon32Url: buildBrandAssetUrl('img/favicon-32x32.png'),
});

export const alucertoBrand: BrandDefinition = {
  key: 'alucerto',
  config: defineBrandConfig({
    displayName: 'Alucerto',
    appName: 'Alucerto',
    siteTitle: 'Alucerto',
    copyrightLabel: 'Alucerto',
    assets: {
      ...buildDefaultAssets(),
      footerLogoUrl: buildBrandAssetUrl('img/logo.png'),
    },
    export: {
      movimientosFilePrefix: 'movimientos_alucerto',
    },
    texts: createDefaultBrandTexts('Alucerto'),
  }),
  logoBase64: alucertoLogo,
  themeVariables: defineThemeVariables({
    '--primary': '#00aeef',
    '--primary-op50': '#00afef83',
    '--primary-op80': '#00afefcc',
    '--primary-dark': '#0097ef',
    '--primary-darker': '#008fef',
    '--secondary': '#414042',
    '--success': '#3fb93b',
    '--warning': '#eaaa21',
    '--bg-surface': '#ffffff',
    '--sidebar-hover': 'rgba(0, 174, 239, 0.08)',
    '--sidebar-active': 'rgba(0, 174, 239, 0.14)',
    '--separator-color': 'rgba(0, 174, 239, 0.12)',
    '--gray-light': '#bababa',
    '--content-text-color': '#343a40',
    '--content-lighter-text-color': '#6c757d',
    '--form-input-text-color': '#343a40',
    '--form-placeholder-color': '#6c757d',
    '--form-input-border-color': '#ced4da',
    '--form-input-focus-border-color': '#00aeef',
    '--nav-card-bg-menu-default': '#ffffff',
    '--nav-card-bg-menu-home': '#ffffff',
    '--font-family-sans-serif':
      '"Montserrat", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    '--body-font-family':
      '"Montserrat", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  }),
};
